export default {
    install(Vue, options = {}) {
        const TIMEOUT = options.timeout || 30 * 60 * 1000 // default: 30 minuti
        let inactivityTimer = null

        // 🔴 Funzione da chiamare allo scadere del timeout
        function handleInactivity(router) {
            removeListeners()
            if (router) {
                router.push('/logout')
            }
        }

        // 🔄 Reset del timer
        function resetTimer(router) {
            if (inactivityTimer) {
                clearTimeout(inactivityTimer)
            }
            inactivityTimer = setTimeout(() => handleInactivity(router), TIMEOUT)
        }

        // ▶️ Aggiunge gli event listeners
        function setupListeners(router) {
            const events = ['mousemove', 'keydown', 'click', 'touchstart']
            events.forEach(e => window.addEventListener(e, () => resetTimer(router)))
            resetTimer(router) // avvio subito il primo timer
        }

        // ⏹️ Rimuove i listener
        function removeListeners() {
            const events = ['mousemove', 'keydown', 'click', 'touchstart']
            events.forEach(e => window.removeEventListener(e, resetTimer))
            if (inactivityTimer) {
                clearTimeout(inactivityTimer)
                inactivityTimer = null
            }
        }

        // ✅ Inizializzazione automatica quando Vue è pronto
        Vue.mixin({
            mounted() {
                if (this.$router && this.$root === this) {
                    // inizializza solo sul root (App.vue)
                    setupListeners(this.$router)
                }
            },
            beforeDestroy() {
                if (this.$root === this) {
                    removeListeners()
                }
            }
        })
    }
}